<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center block-fullscreen-text">
      <div class="title-main">
        <h1>
          Link de diagnóstico inválido.
        </h1>        
      </div>
    </section>
  </div>
</template>

<script>
import Icon from '../Icon';
import rollDown from '../mixins/rollDown';

/* eslint-disable max-len */
export default {
  name: 'intro',
  mixins: [rollDown],
  components: { Icon },
  data() {
    return {
      nextScreen: '/teste/cultura-e-lideranca',
      username: this.$store.state.username
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/test/InvalidLink.vue